import React 		from 'react';
import ReactDOM 	from 'react-dom';
import BLComponent	from '../../core/_BLComponent.jsx';

import VideoContent from '../../common/_VideoContent.jsx';

export default class WebinarVideo extends BLComponent {
	constructor (props, context) {
		super(props, context);

		this.currentDate 		= blapp.config.server_time;
		this.series 				= blapp.models.get('listSeries') || [];
		this.seriesNumber 	= parseInt(blapp.util.getUrlInfo(window.location.href).path.split('/')[3].split('-')[1]); 
	}

	render() {
		const {classes = ''} 	= this.props;
		const seriesContent 	= this.returnSeriesContent();
		const hasWebinarVideo = seriesContent && seriesContent.strWebinarVideoURL && seriesContent.strWebinarVideoTitle && seriesContent.strWebinarVideoDescription;

		if(hasWebinarVideo) {
			return (
				<article className={`bdp-series-main__webinar-video-block ${classes}`}>
					<div className="bdp-series-main__webinar-video">
						<VideoContent url={seriesContent.strWebinarVideoURL}/>
					</div>
					<div className="bdp-series-main__announcement-block-content bdp-series-main__announcement-block-content--landing bg-color--white text--left">
						<p className="text--title l-margin-bottom"><strong className="text-color--darkestBlue">{seriesContent.strWebinarVideoTitle}</strong></p>
						<div className="text--small-title" dangerouslySetInnerHTML={{__html: seriesContent.strWebinarVideoDescription}}></div>
					</div>
				</article>
			);
		}else{
			return false;
		}
	}

	returnSeriesContent() {
		const {source = "", seriesNum = false} = this.props;
		let seriesContent;

		if(seriesNum) {
			seriesContent = seriesNum ? this.series[this.series.findIndex(series => series.idSeries == seriesNum)] : this.series[this.series.findIndex(series => series.strWebinarText && series.strWebinarRegistrationURL && (series.udtWebinarDate && this.currentDate <= series.udtWebinarDate))];
		}else{
			seriesContent = this.seriesNumber ? this.series[this.series.findIndex(series => series.idSeries == this.seriesNumber)] : this.series[this.series.findIndex(series => series.strWebinarText && series.strWebinarRegistrationURL && (series.udtWebinarDate && this.currentDate <= series.udtWebinarDate))];
		}

		return seriesContent;
	}
}